const appleStoreButtonAltText = 'Apple App Store';
const appleStoreLink = 'https://apps.apple.com/us/app/tempus-covid-19/id1511865908';
const googlePlayButtonAltText = 'Google Play Store';
const googlePlayLink = 'https://play.google.com/store/apps/details?id=com.tempusid';

export { appleStoreButtonAltText, appleStoreLink, googlePlayButtonAltText, googlePlayLink };
